import { useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { supabase } from './lib/supabase'
import Layout from './components/Layout'
import Login from './pages/Login'
import Home from './pages/Home'
import Indicadores from './pages/Indicadores'
import Dashboard from './pages/Dashboard'
import Fcas from './pages/Fcas'
import Gestores from './pages/Gestores'
import Reunioes from './pages/Reunioes'
import MensagemWhatsapp from './pages/MensagemWhatsapp'
import ResetPassword from './pages/ResetPassword'
import AnalyticsAderencia from './pages/AnalyticsAderencia'
import AnalyticsFcas from './pages/AnalyticsFcas'
import AnalyticsMetas from './pages/AnalyticsMetas'
import Logs from './pages/Logs'
import Empresas from './pages/Empresas'
import './index.css'

function ChangePasswordOverlay() {
  const { user, refreshProfile, signOut } = useAuth()
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    if (newPassword.length < 6) return setError('A senha deve ter pelo menos 6 caracteres.')
    if (newPassword !== confirmPassword) return setError('As senhas não coincidem.')
    setSaving(true)
    const { error: authError } = await supabase.auth.updateUser({ password: newPassword })
    if (authError) { setSaving(false); return setError('Não foi possível alterar a senha. Tente novamente.') }
    await supabase.from('profiles').update({ must_change_password: false }).eq('id', user.id)
    await refreshProfile()
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, padding: 20
    }}>
      <div className="card" style={{ width: '100%', maxWidth: 380 }}>
        <div style={{
          width: 44, height: 44, borderRadius: '50%', background: '#fff8e1',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px', fontSize: 22
        }}>🔑</div>
        <h2 style={{ textAlign: 'center', fontSize: 17, marginBottom: 8 }}>Defina sua senha</h2>
        <p style={{ color: 'var(--text2)', fontSize: 13, textAlign: 'center', marginBottom: 20 }}>
          Você está usando uma senha temporária. Crie uma senha pessoal para continuar.
        </p>
        <form onSubmit={handleSubmit}>
          {error && <div className="alert alert-error" style={{ marginBottom: 16 }}>{error}</div>}
          <div className="form-group">
            <label>Nova senha</label>
            <input
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Confirmar nova senha</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Repita a senha"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: 6 }} disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar senha'}
          </button>
        </form>
        <button
          onClick={signOut}
          style={{
            width: '100%', marginTop: 10, background: 'none', border: 'none',
            color: 'var(--text2)', fontSize: 13, cursor: 'pointer', padding: '4px 0'
          }}
        >
          Sair
        </button>
      </div>
    </div>
  )
}

function PrivateRoute({ children }) {
  const { user, profile, loading } = useAuth()
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', color: 'var(--text2)', fontSize: 13 }}>Carregando...</div>
  if (!user) return <Navigate to="/login" replace />
  return (
    <>
      {profile?.must_change_password && <ChangePasswordOverlay />}
      {children}
    </>
  )
}

function AdminRoute({ children }) {
  const { isAdmin, isSuperAdmin, loading } = useAuth()
  if (loading) return null
  return (isAdmin || isSuperAdmin) ? children : <Navigate to="/" replace />
}

function SuperAdminRoute({ children }) {
  const { isSuperAdmin, loading } = useAuth()
  if (loading) return null
  return isSuperAdmin ? children : <Navigate to="/" replace />
}

function AppRoutes() {
  const { user } = useAuth()
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Home />} />
        <Route path="indicadores" element={<Indicadores />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="dashboard/:id" element={<Dashboard />} />
        <Route path="fcas" element={<Fcas />} />
        <Route path="gestores" element={<AdminRoute><Gestores /></AdminRoute>} />
        <Route path="reunioes" element={<AdminRoute><Reunioes /></AdminRoute>} />
        <Route path="whatsapp" element={<AdminRoute><MensagemWhatsapp /></AdminRoute>} />
        <Route path="logs" element={<AdminRoute><Logs /></AdminRoute>} />
        <Route path="analytics/aderencia" element={<AnalyticsAderencia />} />
        <Route path="analytics/fcas" element={<AnalyticsFcas />} />
        <Route path="analytics/metas" element={<AdminRoute><AnalyticsMetas /></AdminRoute>} />
        <Route path="empresas" element={<SuperAdminRoute><Empresas /></SuperAdminRoute>} />
      </Route>
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}
